import baseRepository from '@/repository/BaseRepository'
import { getStoredEndDate } from '@/lib/localStorage'
import type {
  ClientSettings,
  GetClientsWidgetDataViewModel,
  GetRepartitionClientsParAgenceViewModel,
  PaginationOffsetResponseModel_GetNewClientsViewModel,
} from '@/lib/types'

export default {
  async getInfoCardData(): Promise<GetClientsWidgetDataViewModel> {
    const url = await baseRepository.buildUrl(`api/widgets/card-clients/${getStoredEndDate()}`)
    return baseRepository.fetchData<GetClientsWidgetDataViewModel>(url)
  },

  async getSettings(): Promise<ClientSettings> {
    return baseRepository.fetchData<ClientSettings>(
      await baseRepository.buildUrl('api/widgets/card-clients/settings'),
    )
  },

  async getRepartitionData(): Promise<GetRepartitionClientsParAgenceViewModel[]> {
    const url = await baseRepository.buildUrl(
      `api/widgets/card-repartition-clients-par-agence/${getStoredEndDate()}`,
    )
    return baseRepository.fetchData<GetRepartitionClientsParAgenceViewModel[]>(url)
  },

  async getTableData(
    skip: number,
    take: number,
    sort_field: string = '',
    sort_order: 'asc' | 'desc',
  ): Promise<PaginationOffsetResponseModel_GetNewClientsViewModel> {
    const params = {
      offset: skip.toString(),
      limit: take.toString(),
      order_by: sort_field,
      order_direction: sort_order,
    }
    const url = await baseRepository.buildUrl(
      `api/widgets/card-details-clients/${getStoredEndDate()}`,
      params,
    )
    return baseRepository.fetchData<PaginationOffsetResponseModel_GetNewClientsViewModel>(url)
  },
  async downloadExcel(): Promise<void> {
    await baseRepository.downloadExcelFile(
      `api/widgets/card-details-clients/${getStoredEndDate()}/excel`,
      `clients_${getStoredEndDate()}.xlsx`,
    )
  },
}
